import { Dialog, DialogActions, styled, Theme } from '@material-ui/core';

export const StyledDialog = styled(Dialog)<Theme>(({ theme }) => ({
  '& .MuiDialog-paperScrollPaper': {
    padding: 0,
    overflowY: 'hidden',
  },
  '& .MuiDialogContent-root': {
    paddingBottom: '16px',
  },
  '& .MuiDialogTitle-root': {
    borderBottom: `2px solid ${theme.palette.studyCard.grey}`,
  },
  '& .MuiDialogActions-root': {},
}));

export const StyledDialogActions = styled(DialogActions)<Theme>(({ theme }) => ({
  height: '56px',
  borderTop: `2px solid ${theme.palette.studyCard.grey}`,
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px 24px',
}));

export const StyledForm = styled('form')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
}));

export const ContentTitleWrapper = styled('div')<Theme>(({ theme }) => ({
  marginTop: '16px',
  marginBottom: '8px',
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  alignItems: 'center',
}));
